import React from 'react'
import FlexView from 'react-flexview/lib'
import { Equipment } from '../../../models/hull-models/Equipment'
import { SkyPaper } from '../Frames/SkyPaper'
import { getSvg } from './EquipmentView'
import { FirebaseService, FirebaseConfigKey } from '../../../services/FirebaseService'
import { BrowserView, MobileView } from 'react-device-detect'
import { isUK } from '../../../services/utils'

interface ClaimEquipmentViewProps {
    equipment: Equipment
}

export const ClaimEquipmentView = ({equipment, ...props}: ClaimEquipmentViewProps) => {
    return (
        <FlexView className="space-between">
            <FlexView vAlignContent={'center'}>
                <SkyPaper small>
                    {getSvg(equipment.type)}
                </SkyPaper>
                <div className="margin-left-basic">
                    <div className="black bold text-small">{equipment.quantity + 'x - ' + equipment.type}</div>
                    <div className="gray text-tiny margin-top-3">{ equipment.description + (equipment.serial? ' ' + equipment.serial : '')}</div>
                    {equipment.deductible > 0 && !isUK() && <FlexView column vAlignContent={'center'} className="margin-top-3 full-height">
                    <div className="gray bold text-tiny margin-top-3">Deductible: {FirebaseService.getValue(FirebaseConfigKey.CURRENCY_SYMBOL)}{equipment.deductible.toLocaleStringToFixed()}</div>
                </FlexView>}
                </div>
            </FlexView>
        </FlexView>
    )
}